import { prop } from 'ramda';

import { InnovationByLaPosteSliceType } from '../../../../types/slice';

export const illustrationSlice = ({ primary }) => {
  return {
    type: InnovationByLaPosteSliceType.ILLUSTRATION,
    value: prop('illustration', primary),
  };
};
